<template>
    <basic-content-layout id="about-cancel-subscription-page" class="content">
        <section id="how-to-cancel">
            <b-container class="mb-5">
                <h1 class="display-3 mt-5">{{ $t('content.subscription.cancellation.title') }}</h1>
                <b-row>
                    <b-col cols="12" class="mb-3">
                        <p>{{ $t('content.subscription.cancellation.description') }}</p>
                    </b-col>

                    <b-col cols="12" class="mb-3">
                        <b-alert variant="success" :show="requestSucceeded">
                            <p class="font-weight-bold">{{ $t('content.subscription.cancellation.success.title') }}</p>
                            {{ $t('content.subscription.cancellation.success.description') }}
                        </b-alert>
                    </b-col>

                    <b-col cols="6" class="mb-3">
                        <b-form-group
                            :label="$t('global.fields.mail.label')"
                            label-for="mail"
                            class="mb-0"
                        >
                            <b-form-input
                                id="mail"
                                v-model="fields.mail.value"
                                :state="fields.mail.state"
                                :placeholder="$t('global.fields.mail.placeholder')"
                                aria-describedby="mail-error"
                            ></b-form-input>
                            <b-form-invalid-feedback id="mail-error">
                                {{ fields.mail.error }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="mb-3">
                        <b-form-group
                            :label="$t('global.fields.password.label')"
                            label-for="password"
                            class="mb-0"
                        >
                            <b-form-input
                                id="password"
                                v-model="fields.password.value"
                                :state="fields.password.state"
                                type="password"
                                aria-describedby="password-error"
                            ></b-form-input>
                            <b-form-invalid-feedback id="password-error">
                                {{ fields.password.error }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="6" class="mb-3">
                        <b-form-group
                            :label="$t('global.fields.subscriptionId.label')"
                            label-for="subscriptionId"
                            class="mb-0"
                        >
                            <b-form-input
                                id="subscriptionId"
                                v-model="fields.subscriptionId.value"
                                :state="fields.subscriptionId.state"
                                :placeholder="$t('global.fields.subscriptionId.placeholder')"
                            ></b-form-input>
                            <b-form-invalid-feedback id="subscriptionId-error">
                                {{ fields.subscriptionId.error }}
                            </b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col cols="12" class="mb-3">
                        <small>{{ $t('content.subscription.cancellation.disclaimer') }}</small>
                    </b-col>
                    <b-col cols="12">
                        <b-button variant="danger" @click="submit" v-if="!isSubmitting">{{ $t('content.subscription.cancellation.button') }}</b-button>
                        <b-button variant="danger" @click="submit" v-else disabled>{{ $t('content.subscription.cancellation.button') }}</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </section>
    </basic-content-layout>
</template>
<script>
import BasicContentLayout from '../../layouts/BasicContentLayout.vue'
import CatalogPageHeader from "../../components/organisms/CatalogPageHeader.vue";
import { BContainer, BRow, BCol, BButton, BFormInput, BFormGroup, BFormInvalidFeedback, BAlert } from "bootstrap-vue";
export default {
    components: {
        BasicContentLayout,
        CatalogPageHeader,
        BContainer, BRow, BCol, BButton,
        BFormInput, BFormGroup, BFormInvalidFeedback, BAlert
    },
    data() {
        return {
            error: false,
            errorSum: 0,
            requestSucceeded: false,
            isSubmitting: false,
            fields: {
                mail: {
                    value: '',
                    state: null,
                    error: this.$t('co.error.required_field')
                },
                password: {
                    value: '',
                    state: null,
                    error: this.$t('co.error.required_field')
                },
                subscriptionId: {
                    value: '',
                    state: null,
                    error: this.$t('co.error.required_field')
                },
            },
        }
    },
    methods: {
        submit() {
            this.validateForm()
            this.error = false

            if(this.errorSum === 0){
                this.isSubmitting = true
                this.$axios.post('api/v1/subscription/cancel', {
                    email : this.fields.mail.value,
                    password : this.fields.password.value,
                    order_number : this.fields.subscriptionId.value,
                }).then(response => {
                    this.isSubmitting = false
                    if(response.data){
                        this.requestSucceeded = true
                        this.fields.mail.value = ''
                        this.fields.password.value = ''
                        this.fields.subscriptionId.value = ''
                    } else {
                        // no success, but we like to show "everything is ok"
                        this.error = true
                        this.requestSucceeded = true
                        this.fields.mail.value = ''
                        this.fields.password.value = ''
                        this.fields.subscriptionId.value = ''
                    }
                }).catch(error => {
                    // no success, but we like to show "everything is ok"
                    this.isSubmitting = false
                    this.error = true
                    this.requestSucceeded = true
                    this.fields.mail.value = ''
                    this.fields.password.value = ''
                    this.fields.subscriptionId.value = ''
                });
            }
        },
        validateForm() {
            this.errorSum = 0
            this.validateEmail()
            this.validatePassword()
            this.validateSubscriptionId()
        },
        validateEmail(){
            this.fields.mail.state = this.fields.mail.value !== ''
            if(!this.fields.mail.state){
                this.errorSum++
            }
        },
        validatePassword(){
            this.fields.password.state = this.fields.password.value !== ''
            if(!this.fields.password.state){
                this.errorSum++
            }
        },
        validateSubscriptionId(){
            this.fields.subscriptionId.state = this.fields.subscriptionId.value !== ''
            if(!this.fields.subscriptionId.state){
                this.errorSum++
            }
        },
    },
    head: {
        title: function () {
            return {
                inner: this.$root.whitelabel.state.settings.meta_title,
                complement: this.$t('meta.aboutCancelSubscription.title')
            }
        },
        meta: function () {
            return [
                { name: 'description', content: this.$t('meta.aboutSubscription.description') }
            ]
        }
    },
}
</script>
